export enum actionTypes {
  GET_AVISOS_FILTRADOS = 'GET_AVISOS_FILTRADOS',
  GET_AVISOS_FILTRADOS_SUCCESS = 'GET_AVISOS_FILTRADOS_SUCCESS',
  GET_AVISOS_FILTRADOS_ERROR = 'GET_AVISOS_FILTRADOS_ERROR',
  GET_AVISOS_FILTRADOS_RESET = 'GET_AVISOS_FILTRADOS_RESET',
}

export enum AvisosFiltradosStatus {
  Idle,
  Loading,
  Error,
  Success,
}

export interface Aviso {
  id: number
  idPais: number
  tipo: string
  estado: string
  titulo: string
  fechaFinalizacion: string
  links: [
    {
      rel: string
      href: string
    }
  ]
  totalPostulaciones: string
  totalCurriculumsSinLeer: string
  referencia: string
}

export interface Paginado {
  currentPage: number,
  totalPages: number,
  elementsPerPage: number,
  totalElements: number
}

export interface ListadoAvisos {
  avisos: Aviso[],
  paginado: Paginado
}

export interface AvisosFiltradosState {
  avisosFiltrados: Aviso[] | null
  paginado: Paginado | null
  avisosFiltradosStatus: AvisosFiltradosStatus
}

export const initialState: AvisosFiltradosState = {
  avisosFiltrados: null,
  paginado: null,
  avisosFiltradosStatus: AvisosFiltradosStatus.Idle,
}

export interface GetAvisosFiltrados {
  type: typeof actionTypes.GET_AVISOS_FILTRADOS
  payload: null
}

export interface GetAvisosFiltradosSuccess {
  type: typeof actionTypes.GET_AVISOS_FILTRADOS_SUCCESS
  payload: ListadoAvisos
}

export interface GetAvisosFiltradosError {
  type: typeof actionTypes.GET_AVISOS_FILTRADOS_ERROR
  payload: boolean
}

export interface GetAvisosFiltradosReset {
  type: typeof actionTypes.GET_AVISOS_FILTRADOS_RESET
  payload: null
}

export type AvisosFiltradosAction =
  | GetAvisosFiltrados
  | GetAvisosFiltradosSuccess
  | GetAvisosFiltradosError
  | GetAvisosFiltradosReset
